import { asyncActionCreator } from '../../global/redux';
import * as constants from './constants';

export const getComparisonUsersDataAction = asyncActionCreator(constants.GET_COMPARISON_USERS_DATA);

export default getComparisonUsersDataAction;
